<div class="blue-box-container"><span>Note: </span>You will need to check-out this document to make adjustments. Add an optional comment below, and click the 'Check-Out' button to download this file. Once you have made the necessary adjustments, you can revisit this screen to check-in the updated document.</div>
<mat-form-field appearance="outline" class="w-p-100 m-t-10">
  <mat-label>Add comment (Optional)</mat-label>
  <textarea [(ngModel)]="message" matInput placeholder=""></textarea>
</mat-form-field>
